import { s } from '@/theme/tokens';
import { toolbarControlRadius } from '../tableSystem/tableToolbar.helpers';
import type { SxProps, Theme } from '@/ui/primitives';

type BuildMetricsToolbarSearchContainerSxArgs = {
  toolbarControlSize: number;
  toolbarExpandedSearchWidth: number;
};

type BuildMetricsToolbarSearchFieldSxArgs = {
  toolbarControlSize: number;
  toolbarSearchWidthPx: string;
};

export const buildMetricsToolbarSearchContainerSx = ({
  toolbarControlSize,
  toolbarExpandedSearchWidth,
}: BuildMetricsToolbarSearchContainerSxArgs): SxProps<Theme> => ({
  width: toolbarExpandedSearchWidth,
  height: toolbarControlSize,
  minHeight: toolbarControlSize,
  minWidth: toolbarExpandedSearchWidth,
  ml: s('md'),
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

export const buildMetricsToolbarSearchFieldSx = ({
  toolbarControlSize,
  toolbarSearchWidthPx,
}: BuildMetricsToolbarSearchFieldSxArgs): SxProps<Theme> => ({
  width: toolbarSearchWidthPx,
  minWidth: toolbarSearchWidthPx,
  maxWidth: toolbarSearchWidthPx,
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
    height: `${String(toolbarControlSize)}px !important`,
    borderRadius: `${toolbarControlRadius} !important`,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: `${toolbarControlRadius} !important`,
  },
  '& .MuiInputBase-input, & .MuiOutlinedInput-input': {
    height: `${String(toolbarControlSize)}px !important`,
    paddingLeft: `${s('sm')} !important`,
    paddingInlineStart: `${s('sm')} !important`,
  },
});
